import { useContext, useEffect } from 'react';
import { useInView } from 'react-intersection-observer';
import { modalZIndex } from '~/constants/srp/zIndex';
import { useTrackEvent } from '~/context/common/AnalyticsProvider';
import ModalContext from '~/context/srp/ModalContext';
import SaveSearchButton from './SaveSearchButton';

function SaveSearchTutorial() {
  const { isSaveSearchNudgeOpen } = useContext(ModalContext);
  const trackEvent = useTrackEvent();
  const [ref, inView] = useInView({ triggerOnce: true });

  useEffect(() => {
    if (inView) trackEvent('Save Search tutorial viewed');
  }, [inView, trackEvent]);

  return isSaveSearchNudgeOpen ? (
    <div
      className="pointer-events-none absolute -bottom-12 -left-16 -right-16 -top-12 flex items-center justify-center rounded-full bg-background-default"
      style={{ zIndex: modalZIndex }}
      ref={ref}
    >
      <SaveSearchButton />
    </div>
  ) : null;
}

export default function SaveSearch() {
  return (
    <div className="grid grid-cols-[auto_1fr] items-center gap-x-sm">
      <div className="relative">
        <SaveSearchTutorial />
        <SaveSearchButton />
      </div>
    </div>
  );
}
